module.exports = __webpack_public_path__ + "img/correct-c.90286a1c.svg";